import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.7237149,1.7407512 L5.03107442,7.43339168 C5.01059867,7.2918843 5,7.14717987 5,7 L5,3 C5,1.34314575 6.34314575,8.74205418e-15 8,8.43769499e-15 C9.20712971,8.21594886e-15 10.2477397,0.712955473 10.7237149,1.7407512 Z M5.86658369,13.6689502 L7.55506072,11.9804732 C7.70164905,11.9933995 7.85005371,12 8,12 C10.7614237,12 13,9.76142375 13,7 L15,7 C15,10.5264719 12.3922941,13.4438815 9,13.9291111 L9,16 L7,16 L7,13.9291111 C6.61095872,13.8734631 6.23223664,13.7858262 5.86658369,13.6689502 Z M1.9467552,10.5177109 C1.34480397,9.48411168 1,8.28232248 1,7 L3,7 C3,7.72413193 3.15393635,8.41231011 3.43087031,9.03359578 L1.9467552,10.5177109 Z M2,15.4142136 L0.585786438,14 L14,0.585786438 L15.4142136,2 L2,15.4142136 Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-mic-muted"}) } }